<template>
  <div class="leak-thirty-days">
    <div class="leak-title">
      Last 30 Days of Leak History
    </div>
    <div class="leak-row-container margin-top-4">
      <div
        v-for="(event, idx) in leakHistory.data"
        :key="idx"
      >
        <div :class="[event ? 'active-block' : 'not-active-block']" />
      </div>
    </div>
    <div class="leak-row-container margin-top-4">
      <div class="leak-text">
        {{ leakHistory.startDay }} - {{ leakHistory.startDate }}
      </div>
      <div class="leak-text">
        {{ leakHistory.endDay }} - {{ leakHistory.endDate }}
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import leadDetailMixin from '@shared/mixins/leadDetailMixin';

export default {
  name: 'ThirtyDaysLeakHistory',
  mixins: [leadDetailMixin],
  computed: {
    leakHistory() {
      if (!this.activeAlertList || this.activeAlertList.length === 0) {
        return [];
      }
      const {
        graphData,
      } = this.activeAlertList[0];

      const leakHistoryData = [];

      for (let i = 0; i < 30; i += 1) {
        const date = moment().subtract((30 - i), 'days').format('YYYY-MM-DD');
        const alertExist = graphData.find((data) => {
          const [alertDate] = Object.keys(data);
          return moment(alertDate).format('YYYY-MM-DD') === date;
        });
        leakHistoryData.push(!!alertExist);
      }

      const starting = moment().subtract(30, 'days');
      const startDay = moment(starting).format('dddd');
      const startDate = moment(starting).format('MM/DD/YYYY');
      const endDay = moment().subtract(1, 'days').format('dddd');
      const endDate = moment().subtract(1, 'days').format('MM/DD/YYYY');

      return {
        data: leakHistoryData,
        endDay,
        endDate,
        startDate,
        startDay,
      };
    },
  },
};
</script>

<style lang="scss">

.leak-thirty-days {
  height: 100px;
  background-color: $WHITE;
  padding: 1rem;
  display: grid;
  align-items: center;
  .leak-title {
    text-align: center;
    line-height: 8px;
    font-weight: 400;
    font-size: 8pt;
  }
  .leak-row-container {
    display: grid;
    grid-auto-flow: column;
    justify-content: space-between;
    padding: 0 1rem;
    .active-block {
      width: 0.85rem;
      height: 0.85rem;
      background-color: $NBLUE100;
    }
    .not-active-block {
      width: 0.85rem;
      height: 0.85rem;
      background-color: $N10;
    }
    .leak-text {
      font-size: 6pt;
      font-weight: 400;
    }
  }
}

</style>
